// @flow
import { Component } from "react";
import { connect } from "react-redux";
import { graphql } from "@apollo/client/react/hoc";
import { get } from "lodash";
import MTPStatusQuery from "./graphql/queries/MTPStatusUpdate.graphql";
import ApolloOptions from "./graphql/options.graph";
import MtpUpdateAction from "./actions";
import type { Props } from "./types";

export class MtpStatusComponent extends Component<Props> {
  static defaultProps = {
    wagerProfile: "PORT-Generic",
    mtpRaces: [],
    children: null,
    removeStartIn: false
  };

  componentDidUpdate() {
    this.props.dispatch(
      MtpUpdateAction(
        get(this.props, "mtpRaces", []),
        get(this.props, "raceDate", [])
      )
    );
  }

  render() {
    return this.props.children;
  }
}

export default connect(
  (store) => ({
    errorTitle: get(store, "capi.messages.nomedamensagem"),
    wagerProfile: get(store, "userData.user.profile", "PORT-Generic")
  }),
  (dispatch) => ({ dispatch })
)(graphql(MTPStatusQuery, ApolloOptions)(MtpStatusComponent));
